import React from "react";
import KycVerificationManagement from "../shared/KycVerificationManagement";

export default function AdminKycVerificationManagement() {
  const getAuthHeader = () => {
    const token = sessionStorage.getItem("token") || localStorage.getItem("token");
    return { Authorization: `Bearer ${token}` };
  };

  return (
    <KycVerificationManagement 
      role="admin" 
      authService={{ getAuthHeader }}
    />
  );
}
